import { render, staticRenderFns } from "./LoadingNotification.vue?vue&type=template&id=ebb28f46&"
import script from "./LoadingNotification.vue?vue&type=script&lang=ts&"
export * from "./LoadingNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports